import debounce from "lodash/debounce";
import { useRef, useCallback, useEffect } from "react";
const useDebouncedCallback = (cb, dependencies, debounceMs = 200) => {
  const callbackRef = useRef(cb);
  const debouncedCallback = useCallback(
    debounce((...args) => {
      callbackRef.current(...args);
    }, debounceMs),
    [debounceMs]
  );
  useEffect(() => {
    callbackRef.current = cb;
  }, [cb, dependencies]);
  return debouncedCallback;
};
export {
  useDebouncedCallback as default
};
//# sourceMappingURL=use-debounced-callback.js.map
